import { AddCircle } from '@mui/icons-material';
import { IconButton } from '@mui/material';
import {FC, useCallback, useState} from 'react';
import { QuickAddJobFunctionModal } from '../../Plays';
import { ClientJobFunctionDto } from '../../../dtos';

export interface IJobFunctionQuickAddButtonProps {
    onNewJobFunctionAdded?: (newJobFunction: ClientJobFunctionDto) => void;
};

export const JobFunctionQuickAddButton: FC<IJobFunctionQuickAddButtonProps> = ({ onNewJobFunctionAdded }) => {
    const [isAddJobFunctionOpen, setAddJobFunctionOpen] = useState<boolean>(false);
    const handleAddJobFunctionClicked = useCallback(() => {
        setAddJobFunctionOpen(true);
    }, []);

    const handleAddJobFunctionClosed = useCallback(() => {
        setAddJobFunctionOpen(false);
    }, []);

    const handleJobFunctionAdded = useCallback((newJobFunction: ClientJobFunctionDto) => {
        setAddJobFunctionOpen(false);
        onNewJobFunctionAdded?.(newJobFunction);
    }, [onNewJobFunctionAdded]);

    return (
        <>
            <IconButton color='primary' onClick={handleAddJobFunctionClicked}>
                <AddCircle />
            </IconButton>
            <QuickAddJobFunctionModal isOpen={isAddJobFunctionOpen} onClose={handleAddJobFunctionClosed} setNewJobFunction={handleJobFunctionAdded} />
        </>
    );
};